// @todo проверить, нужен ли этот no-useless-escape
/* eslint-disable no-useless-escape */

import { months, weekDays } from "./variables";

export const getReadableTime = (date) => {
  const timeInMilliseconds = new Date(Date.parse(date));
  let readableDate = timeInMilliseconds.toLocaleDateString();
  readableDate += ", ";
  readableDate += mapHoursMinutesToCorrectLength(timeInMilliseconds.getHours());
  readableDate += ":";
  readableDate += mapHoursMinutesToCorrectLength(
    timeInMilliseconds.getMinutes()
  );
  readableDate += " ";
  return readableDate;
};

export const mapHoursMinutesToCorrectLength = (str) => {
  if (String(str).length === 1) {
    return "0" + str;
  } else {
    return str;
  }
};

export const getWeekDay = (date) => {
  const dayNum = date.getDay();
  return weekDays[dayNum];
};

export const getMonth = (date) => {
  const monthNum = date.getMonth();
  return months[monthNum];
};

export const getFullName = (string) => {
  const regex = /[А-ЯA-Z][а-яa-zА-ЯA-Z\-]{0,}\s[А-ЯA-Z][а-яa-zА-ЯA-Z\-]{1,}(\s[А-ЯA-Z][а-яa-zА-ЯA-Z\-]{1,})?$/g;
  if (string.match(regex)) {
    return string.match(regex)[0];
  } else {
    return "";
  }
};

export const mapCommentToText = (comment) => {
  comment = comment.replace("<strong>", "");
  comment = comment.replace("</strong>", "");
  comment = comment.replace(",", "");
  comment = comment.replace("Врач: ", "");
  comment =
    comment.split("")[0].toUpperCase() + comment.slice(1, comment.length);
  return comment;
};

export const getDoctorSpeciality = (string, fullName) => {
  return string.replace(fullName, "");
};

export const getErrorStatus = (error) => {
  const regExp = /[1-6][0-9][0-9]/;
  return error.message.match(regExp)[0];
};

export const getErrorMessage = (status) => {
  switch (status) {
    case "401":
      return "Ошибка авторизации";
    default:
      return "Неизвестная ошибка";
  }
};

export const replaceAllDivisiosToDots = (str) => {
  while (str.includes("-")) {
    str = str.replace("-", ".");
  }
  return str;
};

export const getReadableDate = (date) => {
  if (Number.isFinite(date)) {
    date = new Date(date);
  }
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return (
    mapHoursMinutesToCorrectLength(day) +
    "." +
    mapHoursMinutesToCorrectLength(month) +
    "." +
    year
  );
};

export const checkErrorStatusAndExecuteCallback = (error, cb) => {
  if (error.response) {
    if (error.response.status >= 500 && error.response.status < 600) {
      cb();
    }
  }
};

export const parseSnils = (snils) => {
  while (snils.includes(" ")) {
    snils = snils.replace(" ", "");
  }
  while (snils.includes("-")) {
    snils = snils.replace("-", "");
  }
  return snils;
};
